import dayjs from "dayjs";

export const formatDate = (str: string, format = "YYYY/MM/DD"): string => {
  // 日付のみの文字列は、
  // OSのタイムゾーン設定によらず同じ日付を表示するために、
  // Asia/Tokyoのタイムゾーンの日付として読み込み、
  // Asia/Tokyoのタイムゾーンとして出力する。
  return dayjs.tz(str, "Asia/Tokyo").format(format);
};
